export const multiSelectDatatransform = (multiselectData) => {
    let options;
    if (multiselectData) {
        options = multiselectData.map((item, index, element) => {
            let o = Object.assign({});
            if (!item.label && !item.value) {
                if (item.name) {
                    o.label = item.name;
                    o.value = item.id
                    o.tags = item.tags
                    return o;
                } else if (item.keyFieldType) {
                    o.label = item.fieldName
                    o.value = item.fieldName
                    o.keyFieldType = item.keyFieldType
                    o.id = (item.id) ? item.id : null
                    o.tags = item.tags
                    return o
                } else if (item.label) {
                    o.label = item.label;
                    o.value = item.value//o.name;
                    o.tags = item.tags
                    return o;
                } else if (item.id && item.value) {
                    o.label = item.id;
                    o.value = item.value;
                    o.tags = item.tags
                } else {
                    o.label = item;
                    o.value = item
                    return o
                }
            } else {
                return item;
            }


        })
    }
    return options
}
